import {
  SET_LOADER,
  REMOVE_LOADER,
  HIDE_ERRORS,
  HIDE_WARNINGS,
  SHOW_REMOVED_ADS,
  SHOW_REMOVED_CAMPAIGNS,
} from './types';

export const setLoader = (data) => {
  return {
    type: SET_LOADER,
    payload: data
  };
};

export const removeLoader = (data) => {
  return {
    type: REMOVE_LOADER,
    payload: data
  };
};

export const hideErrors = (data) => {
  return {
    type: HIDE_ERRORS,
    payload: data
  };
};

export const hideWarnings = (data) => {
  return {
    type: HIDE_WARNINGS,
    payload: data
  };
};

export const toggleRemovedAds = () => {
  return {
    type: SHOW_REMOVED_ADS,
  };
};

export const toggleRemovedCampaigns = () => {
  return {
    type: SHOW_REMOVED_CAMPAIGNS
  };
};
